import { isEmpty, forEach } from "lodash";

/**
 * 解析
 * @param {string} requestIds 目标requestIds
 * @return {object} { owner }
 */
/**
 * "trigger": {
        "self.BIGTABLE": [{
          "event": "",
          "param": "",
        }]
      }
 */
export const parse = (trigger = {}, options = {}) => {
  const { fieldApi } = options;
  const realTrigger = {};
  if (!isEmpty(trigger)) {
    // 校验 trigger
    forEach(trigger, (value, fieldId) => {
      if (isEmpty(value)) return true;
      realTrigger[fieldId] = value;
    });
  }

  return {
    handler: () => {
      if (isEmpty(realTrigger)) return;
      forEach(realTrigger, (value, fieldId) => {
        if (isEmpty(value)) return true;
        forEach(value, (item) => {
          fieldApi.triggerFieldEvent(fieldId, item.event, item.param);
        });
      });
    },
  };
};
